import * as React from "react";
import type { SVGProps } from "react";
const SvgIcMarketplace = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.514 21.5H8.166c-3.066 0-5.419-1.108-4.75-5.565l.777-6.041c.412-2.225 1.831-3.076 3.076-3.076h10.178c1.264 0 2.6.915 3.076 3.076l.778 6.04c.567 3.955-1.72 5.566-4.787 5.566"
      clipRule="evenodd"
    />
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.651 6.598a4.32 4.32 0 0 0-4.32-4.32 4.32 4.32 0 0 0-4.339 4.32M15.296 11.102h-.045M9.466 11.102H9.42"
    />
  </svg>
);
export default SvgIcMarketplace;
